import i18next from "i18next";
import { ALERTS_CAMPAIGNS_TEXT, YELLOW_ALERT_TYPES } from "./constants";

export const getAlertMessage = (alert) => {
  const alertType = alert.type;

  switch (alertType) {
    case "ALERT_DISAPPROVALS_ISSUES":
      return alert.longMessage || alert.shortMessage || "";
    default:
      return (
        ALERTS_CAMPAIGNS_TEXT[alertType] ||
        alert.longMessage ||
        alert.shortMessage ||
        ""
      );
  }
};

export const getRedAlertsFromCampaign = ({ campaign = {} }) => {
  const platforms = campaign?.platforms || [];
  const platformsData = campaign?.platformsData || {};
  const redAlerts = [];

  platforms.forEach((platform) => {
    const alerts = platformsData?.[platform]?.alerts;
    if (!Array.isArray(alerts) || alerts.length === 0) {
      return;
    }

    const uniqueAlertsByType = new Map();
    alerts.forEach((alert) => {
      const alertType = alert?.type;
      if (!alertType || uniqueAlertsByType.has(alertType)) {
        return;
      }
      if (YELLOW_ALERT_TYPES.includes(alertType)) {
        return;
      }
      const message = getAlertMessage(alert);
      if (!message) {
        return;
      }
      uniqueAlertsByType.set(alertType, {
        platform,
        alertType,
        shortMessage:
          i18next.t(message, { platform: i18next.t(platform) }) || "",
      });
    });

    uniqueAlertsByType.forEach((alertData) => {
      redAlerts.push(alertData);
    });
  });

  return redAlerts;
};

export const getRedAlertsSummaryFromCampaigns = ({ campaigns = {} }) => {
  const redAlerts = [];
  Object.values(campaigns || {}).forEach((campaign) => {
    const campaignRedAlerts = getRedAlertsFromCampaign({ campaign });
    if (campaignRedAlerts.length > 0) {
      redAlerts.push(...campaignRedAlerts);
    }
  });

  return {
    hasRedCampaignAlerts: redAlerts.length > 0,
    redCampaignAlerts: redAlerts,
  };
};
